export default __webpack_public_path__ + "137f43e1d498adfaed3659b0724a2f23.svg";